import * as Raven from 'raven-js';
import * as config from './config';

export function initTelemetry() {
  Raven.config(config.sentryDSN, { release: config.sentryRelease }).install();

  // This is a partially-standardized API called in some browsers when there
  // is an unhandled promise rejection. There's some useful info at
  // https://github.com/getsentry/raven-js/issues/424
  try {
    (window as any).onunhandledrejection = (e: any) => {
      Raven.captureException(e.reason || e);
    };
  } catch (e) {
    // We've seen this fail once before.
    if (e instanceof TypeError) {
      Raven.captureMessage('Unable to assign Raven to window.onunhandledrejection.', { level: 'warn' });
    } else {
      throw e;
    }
  }
}

export function reportError(e: Error) {
  Raven.captureException(e);
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/telemetry.ts